<template>
  <template v-if="filteredItems.length">
    <div class="col-xl-9 m-b-2-5 m-t--1-5 d-none">
      <form class="form--std">
        <div class="filter filter--inline filter--inline-2">
          <template v-if="filteredCompanies.length">
          <div class="filter-item">
            <div class="form-group form-group--inline">
              <label for="query" class="form-label">{{ translation.form.companyTitle }}:</label>
              <div class="select">
                <select
                  v-model="selectedCompany"
                  id="company-select"
                  class="select__control form-control"
                >
                  <option :value="null" selected>{{ translation.form.showAll }}</option>
                  <option v-for="company in filteredCompanies" :value="company.id" :disabled="!getFilteredItems(company.id, selectedRole).length">
                    {{ company.title }}
                  </option>
                </select>
                <span class="select__focus"></span>
              </div>
            </div>
          </div>
          </template>

          <template v-if="filteredRoles.length">
          <div class="filter-item">
            <div class="form-group form-group--inline">
              <label for="query" class="form-label">{{ translation.form.roleTitle }}:</label>
              <div class="select">
                <select
                  v-model="selectedRole"
                  id="role-select"
                  class="select__control form-control"
                >
                  <option :value="null" selected>{{ translation.form.showAll }}</option>
                  <option v-for="role in filteredRoles" :value="role.id" :disabled="!getFilteredItems(selectedCompany, role.id).length">
                    {{ role.title }}
                  </option>
                </select>
                <span class="select__focus"></span>
              </div>
            </div>
          </div>
          </template>
        </div>
      </form>
    </div>

    <div class="col-12">
      <div class="person-item-list item-list">
      <TransitionGroup name="list">
        <div v-for="item in filteredItems" class="person-item item" :key="Math.random()">
          <div class="person-item__inner">
            <div class="person-item__img">
              <img v-if="item.image && item.image[0]" :src="item.image[0].src" class="img-fluid">
              <a v-if="item.linkedInUrl" :href="item.linkedInUrl" class="btn btn--alt person-item__img-btn" title="LinkedIn" target="_blank">In</a>
            </div>
            <div class="person-item__content">
              <h3 v-if="item.title" class="person-item__title">{{ item.title }}</h3>
              <p v-if="item.description" class="person-item__desc">{{ item.description }}</p>
              <p  class="person-item__desc">{{ item.company.title }}</p>
              <p  class="person-item__desc">{{ item.role.title }}</p>
            </div>
          </div>
        </div>
      </TransitionGroup>
      </div>
    </div>
  </template>
</template>

<script>
import { ref, computed, onMounted, watch, inject } from "vue";
import getDataset from "./getDataset";

export default {
  name: "PersonItemList",
  components: {

  },
  setup(props) {
    const { translation, companies, roles, items } = getDataset(inject("componentId"));
    const selectedCompany = ref(null);
    const selectedRole = ref(null);

    function selectCompany(company) {
      selectedCompany.value = company;
      if (selectedRole.value && !getFilteredItems(company, selectedRole.value).length) {
        selectedRole.value = null;
      }
    }

    function selectRole(role) {
      selectedRole.value = role;
    }

    const getFilteredItems = (company = null, role = null) => {
      let filteredItems = items;
      if (company) {
        filteredItems = filteredItems.filter(item=>item.company.id === company)
      }
      if (role) {
        filteredItems = filteredItems.filter(item=>item.role.id === role)
      }
      return filteredItems;
    };

    const filteredItems = computed(() => {
      return getFilteredItems(selectedCompany.value, selectedRole.value);
    })

    const filteredCompanies = computed(() => {
      let filteredItems = getFilteredItems();
      let filteredCompanies = companies.filter((company) => {
        return filteredItems.some((item) => {
          return (item) => item.company === company;
        });
      });
      return filteredCompanies
    })

    const filteredRoles = computed(() => {
      let filteredItems = getFilteredItems();
      let filteredRoles = roles.filter((role) => {
        return filteredItems.some((item) => {
          return (item) => item.role === role;
        });
      });
      return filteredRoles
    })

    return {
      translation,
      companies,
      roles,
      items,
      selectCompany,
      selectedCompany,
      selectRole,
      selectedRole,
      filteredItems,
      filteredCompanies,
      filteredRoles,
      getFilteredItems,
    }
  },
};
</script>
